var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pb-1"
  }, [_vm.filteredData.length > 0 ? _c('div', [_c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var _entry$ownership_assi;

        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'ownership_assigned' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry === null || entry === void 0 ? void 0 : (_entry$ownership_assi = entry.ownership_assigned) === null || _entry$ownership_assi === void 0 ? void 0 : _entry$ownership_assi.name) + " ")]) : column.field === 'total_distance_meter' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry === null || entry === void 0 ? void 0 : entry.total_distance_meter) + "km ")]) : column.field === 'total_income' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(entry.total_income)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }], null, false, 87730491)
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm px-2"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "flex justify-center items-center py-10"
  }, [_vm._v(" - Data tidak tersedia - ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }